module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAoCAYAAACxbNkLAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADsSURBVHgB7dTbCcJAEEbhU8qUYEmWYAdOJ7ZiB5ZgCZagK0RQCGGzt5mJOfA/hvCxMLBn2jntlnZgA70xz2kPgqO+MeFRc5iwqCVMOFQOJgxqDcY9qgTz2RFn1WAUZ+0Y/h0jaRf6Xo6hmDt9z6EJpteNN8W0RrnAtEK5wtSiXGJKUcMwTB+U/CgXNRTzTlj/Qrmo4ZieKDNMD5Q5piXKDaYFqmZKx2QwShmQMAalDEzoi1IMEvqgFMOEtijFQUIblOIooQ6lOEwoQymOE9ahlAAJeSglUMIySgmYMI9SAif8opQNJGnXtBOGvQBtVZbNK2Qz8QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WithdrawalSuccessful/ok.png
// module id = AaXj
// module chunks = 0